import { useMutation, useQueryClient } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../../Context/AuthContext';

const resetOnTripStatus = async (id, token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/hireTruck/trucks/${id}/completed-trucks`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to reset on-trip status');
  }

  return response.json();
};

const useResetTruckStatus = () => {
  const queryClient = useQueryClient();
  const { token } = useContext(AuthContext);

  return useMutation(({ id }) => resetOnTripStatus(id, token), {
    onSuccess: () => {
      queryClient.invalidateQueries(['freightbookrequest']);
    },
  });
};

export default useResetTruckStatus;
